import { Slot } from 'radix-ui';
import type { Slot as SlotNS } from 'radix-ui';
import { forwardRef } from 'react';

export interface IBaseSlotProps extends SlotNS.SlotProps {}

export const BaseSlot = forwardRef<
  HTMLElement,
  IBaseSlotProps
  // eslint-disable-next-line no-restricted-syntax
>(function BaseSlot({ ...props }, ref): JSX.Element {
  return <Slot.Root {...props} ref={ref} />;
});
